import triggerAllApiEvents from '../triggerAllApiEvents';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { getAdapter, RecipientField } from 'owa-addins-apis';
import { getComposeHostItemIndex } from 'owa-addins-store';
import { OutlookEventDispId } from '../schema/OutlookEventDispId';

export function triggerRecipientsChangedEvent(itemId: string, recipientField: RecipientField) {
    const hostItemIndex = getComposeHostItemIndex(itemId);
    const adapter = getAdapter(hostItemIndex);
    if (
        adapter != null &&
        (adapter.mode === ExtensibilityModeEnum.AppointmentOrganizer ||
            adapter.mode === ExtensibilityModeEnum.MessageCompose)
    ) {
        let result = null;
        if (adapter.mode == ExtensibilityModeEnum.MessageCompose) {
            result = { to: false, cc: false, bcc: false };
            switch (recipientField) {
                case RecipientField.To:
                    result.to = true;
                    break;
                case RecipientField.Cc:
                    result.cc = true;
                    break;
                case RecipientField.Bcc:
                    result.bcc = true;
                    break;
            }
        } else if (adapter.mode === ExtensibilityModeEnum.AppointmentOrganizer) {
            result = { requiredAttendees: false, optionalAttendees: false, resources: false };
            switch (recipientField) {
                case RecipientField.RequiredAttendees:
                    result.requiredAttendees = true;
                    break;
                case RecipientField.OptionalAttendees:
                    result.optionalAttendees = true;
                    break;
                case RecipientField.Resources:
                    result.resources = true;
                    break;
            }
        }

        triggerAllApiEvents(
            hostItemIndex,
            OutlookEventDispId.RECIPIENTS_CHANGED_EVENT_DISPID,
            () => {
                return result;
            }
        );
    }
}
